import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const jobsStore = createSlice({
    name: 'jobs',
    initialState: {
        jobsList: [],
        activeIndex: 0, // -1  All
        cartList: [] ,
        cartVisible: false,
        activeBidId: null, // 当前选中的 Bid ID
        currentBidId: null,
    },
    reducers: {
        setActiveBidId (state, action) {
            state.activeBidId = action.payload
            if (state.currentBidId === null) {
                state.currentBidId = action.payload;
            }
        },
        setCurrentBidId(state, action) {
            state.currentBidId = action.payload;
        },
        setJobsList(state, action) {
            // state.jobsList = action.payload;
            console.log("Payload received in setJobsList:", action.payload); // Log payload
            state.jobsList = action.payload;
            console.log("Updated state.jobsList:", state.jobsList); // Log updated state
        },
        changeActiveIndex(state, action) {
            console.log("Payload received in setJobsList:", action.payload, state.activeIndex); // Log payload
            state.activeIndex = action.payload;
            console.log("Updated state.jobsList:", state.jobsList, state.activeIndex); // Log updated state
        },
        // Add to Cart
        addCart(state, action) {
            const item = state.cartList.find(item => item.id === action.payload.id);
            if (item) {
                item.count++;
            }
            else {
                state.cartList.push(action.payload);
            }
        },
        // increaseCount(state, action) {
        //     const item = state.cartList.find(item => item.id === action.payload.id);
        //     item.count++;
        // },
        increaseCount(state, action) {
            const { id, job } = action.payload;
            const item = state.cartList.find(item => item.id === id);

            if (item) {
                item.count++;
            } else {
                state.cartList.push({
                    ...job,
                    count: 1
                });
            }
        },
        // decreaseCount(state, action) {
        //     const item = state.cartList.find(item => item.id === action.payload.id);
        //     if (item.count === 0) {
        //         return;
        //     }
        //     item.count--;
        // },
        decreaseCount(state, action) {
            const item = state.cartList.find(item => item.id === action.payload.id);
            if (!item) return;

            item.count--;

            if (item.count <= 0) {
                state.cartList = state.cartList.filter(i => i.id !== item.id);
            }
        },
        clearCart(state) {
            state.cartList = [];
        },
        showCart(state) {
            state.cartVisible = true;
        },
        hideCart(state) {
            state.cartVisible = false;
        },
        moveJob: (state, action) => {
            const { index, direction } = action.payload; // direction: 'up' | 'down'
            const newIndex = direction === 'up' ? index - 1 : index + 1;
            if (newIndex >= 0 && newIndex < state.cartList.length) {
                const temp = state.cartList[index];
                state.cartList[index] = state.cartList[newIndex];
                state.cartList[newIndex] = temp;
            }
        }

    }
});

// Asynchronous data acquisition
// const { setJobsList, changeActiveIndex, addCart, increaseCount, decreaseCount, clearCart } = jobsStore.actions;
const { 
  setJobsList, 
  changeActiveIndex, 
  increaseCount, 
  decreaseCount, 
  clearCart,
  showCart,      
  hideCart,
  moveJob,
  setActiveBidId,
  setCurrentBidId
} = jobsStore.actions;

// const fetchJobsList = (bidSessionId = null) => {
//     return async (dispatch) => {
//         //const res = await axios.get('http://localhost:3004/Jobs');
//         //https://dc28.job-bid.ca/server/jobs.php
//         // const res = await axios.get('https://dc28.job-bid.ca/server/jobs.php');

//         // console.log("res.data:", res.data);

//         // dispatch(setJobsList(res.data));
//         try {
//             // Start with the base URL
//             let url = "https://dc28.job-bid.ca/server/jobs.php";

//             // const res = await axios.get("https://dc28.job-bid.ca/server/jobs.php");
//             // Check if bidSessionId exists, append as a query parameter
//             // We use '?' if it's the first param, or '&' if you had others
//             if (bidSessionId) {
//                 url += `?bid_session_id=${bidSessionId}`;
//             }

//             const res = await axios.get(url);

//             console.log("Fetching from:", url);
//             console.log("res.data:", res.data);
            
//             dispatch(setJobsList(res.data));
//         } catch (error) {
//             console.error("Error fetching jobs:", error);
//         }
//     }
// };

// 在组件外部定义一个简单的缓存对象
const jobPoolCache = {};

const fetchJobsList = (bidSessionId = null) => {
    return async (dispatch) => {
        try {

            const cacheKey = bidSessionId || 'active';
            // 如果缓存里有，直接用
            if (jobPoolCache[cacheKey]) {
                dispatch(setJobsList(jobPoolCache[cacheKey]));
                return jobPoolCache[cacheKey];
            }

            let url = "https://dc28.job-bid.ca/server/jobs.php";
            if (bidSessionId) {
                url += `?bid_session_id=${bidSessionId}`;
            }

            const res = await axios.get(url);
            
            console.log("Fetching from:", url);
            dispatch(setJobsList(res.data));

            // 🌟 必须 return 数据，否则调用方 await 拿不到东西
            return res.data; 
        } catch (error) {
            console.error("Error fetching jobs:", error);
            return null;
        }
    }
};



// export { fetchJobsList, changeActiveIndex, addCart, increaseCount, decreaseCount, clearCart };
export { 
  fetchJobsList, 
  changeActiveIndex, 
  increaseCount, 
  decreaseCount, 
  clearCart,
  showCart,      
  hideCart,
  moveJob,
  setActiveBidId,
  setCurrentBidId 
};

const jobsReducer = jobsStore.reducer;
export default jobsReducer;